{
  "imprint-page": {
    "meta": {
      "title": "Beauty Booking: Thông báo pháp lý",
      "description": "Thông báo pháp lý"
    },
    "text": {
      "title": "Thông báo pháp lý",
      "address-and-contact-data": "ĐỊA CHỈ VÀ DỮ LIỆU LIÊN HỆ THEO § 5 TMG",
      "address": "Địa chỉ",
      "commercial-register": "Đăng ký thương mại",
      "contact": "Liên hệ",
      "email": "E-mail",
      "legal-representatives": "Người đại diện theo pháp luật",
      "liability": "TRÁCH NHIỆM PHÁP LÝ",
      "liability-text-1": "Chúng tôi chịu trách nhiệm về nội dung trang web của mình theo quy định của pháp luật chung, đặc biệt là theo § 7 (1) của Đạo luật Telemedia Đức (TMG). Tất cả nội dung được tạo ra một cách cẩn trọng và theo hiểu biết tốt nhất của chúng tôi. Trong trường hợp chúng tôi đề cập đến Trang web của bên thứ ba bằng các siêu liên kết trên trang web của chúng tôi, chúng tôi không thể đảm bảo bất kỳ sự đảm bảo nào về tính thời sự liên tục, tính chính xác và đầy đủ của các nội dung được liên kết, bởi vì những nội dung này nằm ngoài phạm vi trách nhiệm của chúng tôi và chúng tôi không có ảnh hưởng đến thiết kế trong tương lai. Theo ý kiến của bạn, nếu có bất kỳ nội dung nào vi phạm luật hiện hành hoặc không phù hợp, vui lòng cho chúng tôi biết.",
      "liability-text-2": "Thông tin pháp lý trên trang này cũng như mọi thắc mắc và tranh chấp liên quan đến việc thiết kế trang web này đều tuân theo luật pháp của Cộng hòa Liên bang Đức.",
      "telephone": "Điện thoại",
      "vat-id": "Mã số thuế GTGT (Ust-ID)"
    }
  }
}
